import { PRODUCT_TYPE } from '@/config/product'

const bundleFreebieChecker = type => {
  const bundleFreebieRegex = /free/i

  return type.match(bundleFreebieRegex)
}

const campaignTransform = campaign => {
  if (!campaign) {
    return null
  }

  return {
    slug: campaign.slug ?? null,
    name: campaign.name ?? null,
    type: campaign.type ?? null,
    status: campaign.status ?? null,
    order_limit_group: campaign.order_limit_group ?? null,
    is_vip_preview: campaign.is_vip_preview ?? false,
    is_vip_public_view: campaign.is_vip_public_view ?? false,
    is_vip_convert_by_right:
      campaign.is_vip_convert_by_right ?? false,
    attributes: campaign.attributes ?? {},
  }
}

export const orderDetailTransform = params => {
  return {
    campaign: campaignTransform(params.campaign),

    order: params.order ?? params.ref_id ?? null,
    code: params.code ?? null,
    barcode: params.barcode ?? null,
    branch_id: params.branch_id ?? null,
    branch_code: params.branch_code ?? null,
    deposit_number: params.deposit_number ?? null,

    itec_sale_order_status: params.itec_sale_order_status ?? null,

    receive_branch_name: params.receive_branch_name ?? '',
    receive_date: params.receive_date ?? '',
    receive_time: params.receive_time ?? '',
    receive_branch_address: params.receive_branch_address ?? null,

    slot_table: params.slot_table ?? null,
    payment_decision: params.payment_decision ?? null,

    full_name: params.full_name ?? '',
    phone: params.phone ?? '',
    email: params.email ?? '',
    member_id: params.member_id ?? null,
    address: params?.address?.address ?? '',
    sub_district: params.sub_district ?? '',
    district: params.district ?? '',
    province: params.province ?? '',
    postcode: params.postcode ?? '',

    tax_address: params?.bill_address
      ? {
          tax_id: params?.bill_address?.tax_id ?? '',
          is_tax_invoice:
            params?.bill_address?.is_tax_invoice ?? false,
          tax_invoice_type:
            params?.bill_address?.tax_invoice_type ?? '',

          first_name: params?.bill_address?.first_name ?? '',
          last_name: params?.bill_address?.last_name ?? '',

          company_name: params?.bill_address?.company_name ?? '',
          company_code: params?.bill_address?.company_code ?? '',

          phone: params?.bill_address?.phone ?? '',

          address: params?.bill_address?.address ?? '',
          sub_district: params?.bill_address?.sub_district ?? '',
          district: params?.bill_address?.district ?? '',
          province: params?.bill_address?.province ?? '',
          country: params?.bill_address?.country ?? '',
          postcode: params?.bill_address?.postcode ?? '',
        }
      : null,

    bill_address: {
      first_name: params?.address?.first_name ?? '',
      last_name: params?.address?.last_name ?? '',
      company_code: params?.address?.company_code ?? null,
      company_name: params?.address?.company_name ?? null,
      phone: params?.address?.phone ?? '',
      tax_id: params?.address?.tax_id ?? null,
      address: params?.address?.address ?? '',
      sub_district: params?.address?.sub_district ?? '',
      district: params?.address?.district ?? '',
      province: params?.address?.province ?? '',
      postcode: params?.address?.postcode ?? '',
    },

    paid_at: params.paid_at ?? null,
    total_price: params.total_price ?? 0,
    deposit: params.deposit ?? 0,
    remaining: params.remaining ?? 0,
    coupon_used: params.coupon_used ?? null,
    coupons: params.coupons ?? [],
    discount_coupon: params.discount_coupon ?? 0,
    discount: params.discount ?? 0,
    before_discount: params.before_discount ?? 0,
    shipping_date: params.shipping_date ?? '',
    special_discount_title: params.special_discount_title ?? null,
    guarantee_amount: params.guarantee_amount ?? 0,
    guarantee_payment_status: params.guarantee_payment_status ?? null,

    is_barcode: params.is_barcode ?? false,
    is_deposit: params.is_deposit ?? false,
    is_delivery: params.is_delivery ?? false,
    is_pay_at_store: params.is_pay_at_store ?? false,
    is_show_pay_at_store: params.is_show_pay_at_store ?? false,
    is_pay_at_store_completed:
      params.is_pay_at_store_completed ?? false,
    is_can_extend_pay_at_store:
      params.is_can_extend_pay_at_store ?? false,

    pay_at_store_detail: params.pay_at_store_detail ?? null,
    status: params.status ?? null,
    payment_type_id: params.payment_type_id ?? null,
    payment_type: params.payment_type ?? null,
    payment_selected: params.payment_selected ?? null,
    pay_at_store_expire_at: params.pay_at_store_expire_at ?? null,
    pay_at_store_expire_at_timestamp_bkk:
      params.pay_at_store_expire_at_timestamp_bkk ?? null,
    product_main: {
      id: params.product_main.product_id ?? null,
      name: params.product_main.name ?? null,
      image_url: params.product_main.image_url ?? null,
      price: params.product_main.price ?? null,
      sku: params.product_main.sku ?? null,
    },
    bundle_products: Array.isArray(params.bundle_products)
      ? params.bundle_products
          .map(bundle => {
            return {
              name: bundle.detail.name ?? null,
              type: bundle.detail.type ?? null,
              image_url: bundle.detail.image_url ?? null,
              sku: bundle.sku ?? null,
              price_srp: bundle.detail.price_srp ?? 0,
              price_ship: bundle.detail.price_ship ?? 0,
              price_store: bundle.detail.price_store ?? 0,
              price_deposit: bundle.detail.price_deposit ?? 0,
            }
          })
          .sort((a, b) => {
            const freebieSort =
              bundleFreebieChecker(a.type) &&
              bundleFreebieChecker(b.type)
                ? parseFloat(b.price_srp) - parseFloat(a.price_srp)
                : 0

            return (
              (a.type === PRODUCT_TYPE.MAIN_PRODUCT ? -1 : 0) +
              (b.type === PRODUCT_TYPE.MAIN_PRODUCT ? 1 : 0) +
              freebieSort +
              (a.type === PRODUCT_TYPE.PROMOTION ? 1 : 0) -
              (b.type === PRODUCT_TYPE.PROMOTION ? 1 : 0)
            )
          })
      : [],

    staff_branch_code: params.staff_branch_code ?? null,
    staff_code: params.staff_code ?? null,

    // Trade-in
    is_tradein_completed: params.is_tradein_completed ?? false,
    tradein: params.tradein,
    tradein_type: params.tradein_type ?? null,
    tradein_discount: params.tradein_discount ?? 0,
    tradein_final_price: params.tradein_final_price ?? 0,
    tradein_is_discount_applied:
      params.tradein_is_discount_applied ?? false,
    tradein_vouchers: params.tradein_vouchers ?? [],

    // Expiration
    expire_at: params.expire_at ?? null,
    expire_at_timestamp: params.expire_at_timestamp_bkk ?? null,
    payment_opens_at: params.payment_opens_at ?? null,
    payment_opens_at_timestamp:
      params.payment_opens_at_timestamp ?? null,
    is_vip_pending_payment: params.is_vip_pending_payment ?? false,
    is_payment_open: params.is_payment_open ?? false,
  }
}

export const createOrderPayloadTransform = (payload, params = {}) => {
  const { coupons, queryParam } = params

  const coupon_codes =
    coupons?.length > 0 ? coupons.map(c => c.code) : undefined

  const utm = {
    id: queryParam?.utm_id,
    source: queryParam?.utm_source ?? null,
    medium: queryParam?.utm_medium ?? null,
    campaign: queryParam?.utm_campaign ?? null,
    content: queryParam?.utm_content ?? null,
    term: queryParam?.utm_term ?? null,
  }

  const admin_quota = queryParam?.admin_quota
    ? queryParam?.admin_quota.toLowerCase() === 'true'
    : false

  const is_stockcard = queryParam?.admin_quota ? true : false

  const sc = queryParam?.sc ?? null
  const sbc = queryParam?.branch_code ?? null
  const code = queryParam?.code ?? null

  return {
    ...payload,
    consents: payload?.consents,
    coupon_codes,
    utm,
    admin_quota,
    is_stockcard,
    sc,
    sbc,
    code,
  }
}

export const createVipOrderPayloadTransform = (
  payload,
  params = {},
) => {
  /**
   * VIP order payload transform
   * No need to include payment_type_id, branch_time_id, coupon_code, coupon_codes
   */

  const { queryParam } = params

  const code = queryParam?.code ?? null

  const utm = {
    id: queryParam?.utm_id,
    source: queryParam?.utm_source ?? null,
    medium: queryParam?.utm_medium ?? null,
    campaign: queryParam?.utm_campaign ?? null,
    content: queryParam?.utm_content ?? null,
    term: queryParam?.utm_term ?? null,
  }

  return {
    // Product Info
    product_id: payload?.product_id,
    bundle_products: payload?.bundle_products,

    // Delivery method
    is_delivery: payload?.is_delivery,
    branch_time_id: payload?.branch_time_id,

    // Customer Info
    first_name: payload?.first_name,
    last_name: payload?.last_name,
    customer_identity: payload?.customer_identity,
    phone: payload?.phone,
    email: payload?.email,
    member_id: payload?.member_id,
    address: payload?.address,
    sub_district: payload?.sub_district,
    district: payload?.district,
    province: payload?.province,
    postcode: payload?.postcode,
    for_work: payload?.for_work,

    // Additional Description
    additional_description: {
      brand: payload?.additional_description?.brand,
      model: payload?.additional_description?.model,
      interest_item: payload?.additional_description?.interest_item,
      interest_item_watch:
        payload?.additional_description?.interest_item_watch,
      interest_item_bud:
        payload?.additional_description?.interest_item_bud,
      gender: payload?.additional_description?.gender,
      birth_year: payload?.additional_description?.birth_year,
    },

    // Campaign consents (a VIP link uses the shadow campaign ones)
    consents: payload?.consents,

    code,
    utm,
  }
}

// VIP Payment Submit Payload Transform
export const vipPaymentSubmitPayloadTransform = payload => {
  const payment_selected = {
    term: payload?.payment_selected?.terms ?? null,
    interest: payload?.payment_selected?.interest ?? 0,
    card_type: payload?.payment_selected?.card_type ?? null,
  }

  return {
    payment_type_id: payload?.payment_type_id,
    branch_time_id: payload?.branch_time_id,
    coupon_codes: payload?.coupon_codes,
    payment_selected,
  }
}

// VIP Payment Preview Payload Transform
export const vipPaymentPreviewPayloadTransform = payload => {
  return {
    payment_type_id: payload?.payment_type_id,
    branch_time_id: payload?.branch_time_id,
    coupon_codes: payload?.coupon_codes,
  }
}
